import React, { FC } from 'react'
import ImportMassLegalFeesContainer from 'containers/ImportMassLegalFees'

const ImportMassLegalFeesPage: FC = () => <ImportMassLegalFeesContainer />

export default ImportMassLegalFeesPage
